import script from "./TheAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAwards.vue?vue&type=script&setup=true&lang=js"

import "./TheAwards.vue?vue&type=style&index=0&id=1e2ae96a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2ae96a"]])

export default __exports__